// /c:/Users/Usuario/Documents/ELIAS/radio-player/src/data/fetchs/fetchMediaModal.js

async function fetchMediaModal() {
    try {
        const response = await fetch('https://embajadoresdelgranrey.com/wp-json/wp/v2/media?search=modal');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const images = await response.json();
        const mediaModal = [];

        images.forEach((image) => {
            mediaModal.push(image.guid.rendered);
        });

        return mediaModal;
    } catch (error) {
        console.error('Error fetching daily verse:', error);
        throw error;
    }
}

export default fetchMediaModal;